<template>
  <div id="wrapper" ref="wrapper">
    <header>
      <div class="topBackground">
        <ul id="nav">
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
            background-color="rgba(0, 0, 0, 0.3)"
            text-color="#fff"
            class=""
            active-text-color="#FF8800">
            <el-menu-item index="0">首页</el-menu-item>
            <el-menu-item index="1">关于我们</el-menu-item>
            <el-menu-item index="2">业务项目介绍</el-menu-item>
            <el-submenu index="3">
              <template slot="title">保险产品&服务推介</template>
              <el-menu-item index="3-1">手机碎屏保障</el-menu-item>
              <el-menu-item index="3-2">工程机械设备&道路承运人保险</el-menu-item>
              <el-menu-item index="3-3">综合交通意外险</el-menu-item>
            </el-submenu>
            <el-menu-item index="4">联系我们</el-menu-item>
          </el-menu>
        </ul>
      </div>
    </header>
    <main class="contentModule">
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <footer>
      <div class="contact">
        <div class="contact-unit"><span class="contact-way">WEBSITE: </span>www.xiaobaiqianbao.com</div>
        <div class="contact-unit"><span class="contact-way">TEL: </span>020-82526981</div>
        <div class="contact-unit"><span class="contact-way">E-MAIL: </span>kf@xiaobaibao.com</div>
      </div>
      <div class="icpInfo"><a style="color: #b7B7B7;display: contents" href="https://beian.miit.gov.cn">粤ICP备14098827号</a></div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "wap",
    data() {
      return {
        activeIndex: '1',
        routeList: ['index', 'aboutUs', 'businessIntroduction', 'productList', 'contactUS', ],
      }
    },
    methods:{
      handleSelect(key, keyPath) {
        console.log(key)
        switch (key.toString()) {
          case "0":
            this.$router.push({name: 'index'});
            break;
          case "1":
            this.$router.push({name: 'aboutUs'});
            break;
          case "2":
            this.$router.push({name: 'businessIntroduction'});
            break;
          case "3-1":
            this.$router.push({name: 'introductionPage', query: {saleToken: 'kr7CfMZLMHY77EIHpA3HIg=='}});
            break;
          case "3-2":
            this.$router.push({name: 'equipmentInsurance'});
            break;
          case "3-3":
            this.$router.push({name: 'CTAInsurance'});
            break;
          case "4":
            this.$router.push({name: 'contactUS'});
            break;
        }
        $('footer').removeClass('footerPosition');
      },
      handleScroll(){
        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop,
          pageClientHeight = document.documentElement.clientHeight,
          topBackgroundClientHeight = document.getElementsByClassName("topBackground")[0].clientHeight;

        // 顶部背景图高于浏览器高度，导航栏定位底部
        if (topBackgroundClientHeight > pageClientHeight){
          let height = topBackgroundClientHeight - pageClientHeight;
          if (scrollTop < height){
            $('#nav').addClass('bottomPosition');
          }else {
            if ($('#nav').hasClass('bottomPosition')) $('#nav').removeClass('bottomPosition');
          }
        }

        // 页面向下滚动超过导航栏位置，导航栏定位顶部
        if (scrollTop > (topBackgroundClientHeight - 60)){
          $('#nav').addClass('topPosition');
        }else {
          if ($('#nav').hasClass('topPosition')) $('#nav').removeClass('topPosition');
        }

      }
    },
    mounted() {
      // 页面刷新时，初始化当前导航栏
      for (let i in this.routeList){
        if (this.routeList[i] == this.$route.name){
          this.activeIndex = i;
        }

        if (this.$route.name == 'equipmentInsurance') this.activeIndex = '3-2';
        if (this.$route.name == 'CTAInsurance') this.activeIndex = '3-3';
      }

      // 监听页面滚动，切换导航栏定位
      window.addEventListener('scroll',this.handleScroll,true);
      this.handleScroll();
    },
  }
</script>

<style>
  .el-menu--horizontal .el-menu .el-menu-item {
    height: 48px!important;
    line-height: 48px!important;
  }
  .el-submenu__title {
    padding: 0;
    font-size: 16px!important;
  }

  @media (max-width: 768px) {
    .el-submenu__title {
      font-size: 1rem!important;
    }

  }
</style>
<style scoped>
  @import "../../static/css/common.css";
  .contentModule{
    height: 100%;
    width: 100%;
    background: #FFFFFF;
  }

  .contentModule>section{
    width: auto;
    margin: 0 auto;
  }

  .topBackground{
    position: relative;
    max-height: 67.19rem;
    padding-top: 56%;
    background: url("../../static/images/home/homePage-banner.png") no-repeat center / cover;
  }

  .topBackground>#nav {
    width: 100%;
    height: 60px;
    margin: 0 auto;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 101;
    font-size: 16px;
    font-weight: bold;
  }

  .topPosition{
    position: fixed!important;
    top: 0!important;
  }
  .bottomPosition{
    position: fixed!important;
    bottom: 0!important;
  }

  #nav ul{
    width: 100%;
    overflow: auto;
    display: flex;
    align-items: flex-start;
  }

  #nav li {
    min-width: 19%;
    float: left;
    text-align: center;
  }

  #nav a {
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    color: #b2b2b2;
    -webkit-transition: color .4s linear 0s;
    -moz-transition: color .4s linear 0s;
    -ms-transition: color .4s linear;
    -moz-transition: olor .4s linear 0s;
    transition: color .4s linear 0s
  }

  #nav a:hover {
    color: #fff
  }

  #nav .current a {
    color: #fff
  }

  /deep/ .el-menu.el-menu--horizontal {
    padding-left: 5%;
  }

  /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    /*background-color: rgba(204, 204, 204, 1)!important;*/
  }

  .contact{
    width: 100%;
    color: #ffffff;
    background-color: #484848;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
    padding: 4vh 10%;
  }

  .contact-unit{
    width: auto;
    margin: 2px 2%;
    display: inline-block;
    vertical-align: middle;
  }

  .contact-way{
    color: #b7B7B7;
    font-size: 12px;
    margin-right: 5px;
  }

  .icpInfo{
    width: 100%;
    line-height: 30px;
    text-align: center;
    color: #b7B7B7;
    font-size: .875rem;
    font-weight: bold;
    background-color: #1f1f1f;
  }

  .footerPosition{
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  @media (max-width: 768px) {
    /deep/ .el-menu.el-menu--horizontal {
      padding-left: 0;
    }

    #nav ul{
      width: 100%;
      overflow: auto;
      display: flex;
      align-items: flex-start;
    }
    #nav li {
      /*width: auto!important;*/
      min-width: 100px;
      font-size: 1rem;
    }

    .topBackground{
      position: relative;
      max-height: 25.06rem;
      padding-top: 53%;
      background: url("../../static/images/home/homePageH5-banner.png") no-repeat center / cover;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wap.vue